import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useContext } from "react";
import styled from "styled-components";

import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import { setCurrentStack } from "../../redux/slices/customNavigation";
import { setFirstName } from "../../redux/slices/customer";
import TextInput from "../../components/Inputs/TextInput";

import {
  isSingleSleeperSelector, mattressConfigurationSelector,
  primarySleeperFirstNameSelector,
  secondarySleeperFirstNameSelector,
  setPrimarySleeperName,
  setSecondarySleeperName,
} from "../../redux/slices/mattressConfiguration";
import { MattressBuilderContext } from "./BedSizeSelector/MattressBuilderContext";
import GeneralStepsHeader from "./BedSizeSelector/GeneralStepsHeader";
import HeaderQuestion from "./BedSizeSelector/HeaderQuestion";
import NextButton from "./BedSizeSelector/NextButton";
import {saveMattressConfigurationToLocalStorage} from "../../utils/bedBuilder.utils";
import ReactGA from 'react-ga';

const StyledNameInputContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 95%;
`;

const StyledLabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-left: 11rem;
`;

const StyledHeaderQuestionContainer = styled.div`
  margin-top: 3rem;
  margin-bottom: 1.5rem;
`;

const StyledText = styled.div`
  font-family: noto-sans;
  font-size: 1rem;
  color: white;
  text-align: left;
  margin-top: 3rem;
  font-weight: bold;
`;

const StyledNextButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 20vh;
  width: 100%;
  position: absolute;
  bottom: 0;
`;

const SleeperName = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const primarySleeperFirstName = useSelector(primarySleeperFirstNameSelector);
  const secondarySleeperFirstName = useSelector(
    secondarySleeperFirstNameSelector
  );

  const isValid = () => {
    if (isSingleSleeper) {
      return primarySleeperFirstName !== "";
    } else {
      return primarySleeperFirstName !== "" && secondarySleeperFirstName !== "";
    }
  };

  return (
    <StyledNameInputContainer className="m-4">
      <GeneralStepsHeader></GeneralStepsHeader>
      <StyledHeaderQuestionContainer>
        <HeaderQuestion>{t(isSingleSleeper ? "Customize your bed just for YOU!" : "Customize your bed just for YOU!")}</HeaderQuestion>
        <StyledText>
          {t(isSingleSleeper ? "First name" : "Left side first name")}:
        </StyledText>
        <TextInput
          value={primarySleeperFirstName}
          onChange={value => dispatch(setPrimarySleeperName(value))}
          inputProps={{
            style: { color: "white", fontWeight: "bold" },
          }}
          styles={{
            marginTop: "1rem",
            borderRadius: "10px",
            fontWeight: "bold",
            backgroundColor: "rgba(230, 244, 252, 0.31)",
            // borderColor: theme.COLORS.GREY.borderGrey,
          }}
        />
        {!isSingleSleeper && (
          <>
            <StyledText>{t("Right side first name")}:</StyledText>

            <TextInput
              value={secondarySleeperFirstName}
              onChange={value => dispatch(setSecondarySleeperName(value))}
              inputProps={{
                style: { color: "white", fontWeight: "bold" },
              }}
              styles={{
                marginTop: "1rem",
                borderRadius: "10px",
                fontWeight: "bold",
                backgroundColor: "rgba(230, 244, 252, 0.31)",
                // borderColor: theme.COLORS.GREY.borderGrey,
              }}
            />
          </>
        )}
      </StyledHeaderQuestionContainer>
      <StyledNextButtonContainer>
        <NextButton
          disabled={!isValid()}
          styles={{ marginBottom: "3vh", marginRight: "4vw" }}
          onClick={() => {
            //Update in local storage
            // console.log("saving to local storage");
            ReactGA.pageview('/mattress-builder/height-and-weight');
            saveMattressConfigurationToLocalStorage(mattressConfiguration);
            dispatch(
              setCurrentStack(
                isSingleSleeper ? "singleSleeper" : "doubleSleeper"
              )
            );
          }}
          className="col-12"
          iconComponent={() => (
            <ArrowRightAltTwoToneIcon></ArrowRightAltTwoToneIcon>
          )}
        ></NextButton>
      </StyledNextButtonContainer>
    </StyledNameInputContainer>
  );
};

export default SleeperName;
